import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../axios/axiosInstance";

const initialState = {
    //! ilk mesaj kategorileri
    supportCategoryList: [],
    //! seçili chatin mesajları
    supportMessageList: [],
    supportNonClosedChatList: [],
    supportClosedChatList: [],
    //! bütün chatler
    supportChatList: [],
    //! seçili chat
    selectedChat: null,
    //! seçili kategori
    selectedCategory: null,
    //! alt kategoriler
    subCategoryList: [],
    //! seçili alt kategori
    selectedSubCategory: null,
    //! dosya seçimi 
    selectedFile: null,

    isArchive: false,

    getIsLoading: false,
    getIsError: false,
    addIsLoading: false,
    addIsError: false,

}


  //! kategoriler
  export const getSupportCategory = createAsyncThunk("chat/getSupportCategory", async(_, thunkApi) => {
    try{
  
      const {data} = await axiosInstance.get(`/SupportCategory/GetList?IsRootCategory=true`)
      
      return data.values
    }catch(error){
      return thunkApi.rejectWithValue(error)
    }
  })

  //! devam eden mesajlar
  
  export const getNonClosedChats = createAsyncThunk("chat/getNonClosedChats", async(_, thunkApi) => {
    try{
  
      const {data} = await axiosInstance.get(`/SupportChat/GetNonClosedChatsByUser`)
      
      return data.values
    }catch(error){
      return thunkApi.rejectWithValue(error)
    }
  })

  //! arşivlenen mesajlar
  
  export const getClosedChats = createAsyncThunk("chat/getClosedChats", async(_, thunkApi) => {
    try{
  
      const {data} = await axiosInstance.get(`/SupportChat/GetClosedChatsByUser`)
      
      return data.values
    }catch(error){
      return thunkApi.rejectWithValue(error)
    }
  })

  //! mesajlaşma
  export const sendChatMessage = createAsyncThunk("chat/supportChatMessage", async(message, thunkApi) => {
    try{
      const myFile = new FormData();
      
      myFile.append('file',message.file);
      myFile.append('supportChatId',message.supportChatId);
      myFile.append('message',message.message);
      
      const {data} = await axiosInstance.post(`/SupportChatMessage/Create`, myFile)
      
      return data
    }catch(error){
      return thunkApi.rejectWithValue(error)
    }
  })

  //! mesaj oluşturma
 
  export const createChatMessage = createAsyncThunk("chat/createChatMessage", async(message, thunkApi) => {
    try{
      
      const {data} = await axiosInstance.post(`/SupportChat/Create`, message)
      
      return data
    }catch(error){
      return thunkApi.rejectWithValue(error)
    }
  })

  //! id ile mesaj çekme
  
  export const getSupportChatById = createAsyncThunk("chat/getSupportChatById", async(id, thunkApi) => {
    try{
      
      const {data} = await axiosInstance.get(`/SupportChat/GetById?getBySupportChatId=${id}`)

      return data
    }catch(error){
      return thunkApi.rejectWithValue(error)
    }
  })

  //! konuşma  bitirme talebi
  
  export const closeSupportChatDemand = createAsyncThunk("chat/closeSupportChatDemand", async(id, thunkApi) => {
    try{
      
      const {data} = await axiosInstance.put(`/SupportChat/SendCloseRequestToSupportChat `, id)
      
      return data
    }catch(error){
      return thunkApi.rejectWithValue(error)
    }
  })
  
  //! konuşma bitirme
  export const closeSupportChat = createAsyncThunk("chat/closeSupportChat", async(body, thunkApi) => {
    try{
      
      const {data} = await axiosInstance.put(`/SupportChat/RespondToCloseSupportChatRequest`, body)
      
      return data
    }catch(error){
      return thunkApi.rejectWithValue(error)
    }
  })

  //! okunmamış mesajları oku
  
  export const setMessageRead = createAsyncThunk("chat/setMessageRead", async(body, thunkApi) => {
    try{
      
      const {data} = await axiosInstance.put(`/SupportChat/SetMessageAsRead`, body)
      
      return data
    }catch(error){
      return thunkApi.rejectWithValue(error)
    }
  })


const messageSlice = createSlice({
    name: "message",
    initialState,
    reducers: {
        setSelectedChat: (state, action) => {
          state.selectedChat = action.payload
        },

        setSelectedCategory: (state, action) => {
          state.selectedCategory = action.payload
        },

        setSelectedSubCategory: (state, action) => {
          state.selectedSubCategory = action.payload
        },

        setSubCategoryList: (state, action) => {
          state.subCategoryList = action.payload
        },

        updateSignalRSupportChatList: (state, action) => {
          const isAvailable = state.supportChatList.find(item => item.id === action.payload.id)

          if(isAvailable){
            state.supportChatList = state.supportChatList.map((item) => {
              if(item.id === action.payload.id){
                return action.payload
              }else {
                return item
              }
            })
          }else{
            state.supportChatList = [action.payload, ...state.supportChatList]
          }

          if(state.selectedChat && state.selectedChat.id === action.payload.id){
            state.selectedChat = action.payload
          }
        },

        setSelectedFile: (state, action) => {
          state.selectedFile = action.payload
        },

        setArchiveChat: (state, action) => {
          state.isArchive = !state.isArchive

          if(state.isArchive){
            state.supportChatList = state.supportClosedChatList
          }else{
            state.supportChatList = state.supportNonClosedChatList
          }
        }
    },
    
    extraReducers:(builder)=> {
        builder
        //! kategoriler
        .addCase(getSupportCategory.pending, (state, action) => {
            state.getIsLoading = true
        })
        .addCase(getSupportCategory.fulfilled, (state, action) => {
            state.getIsLoading = false
            state.supportCategoryList = action.payload.$values
        })
        .addCase(getSupportCategory.rejected, (state, action) => {
            state.getIsLoading = false
            state.getIsError = true
        })

        //! devam eden mesajlar
        .addCase(getNonClosedChats.pending, (state, action) => {
          state.getIsLoading = true
        })
        .addCase(getNonClosedChats.fulfilled, (state, action) => {
            state.getIsLoading = false
            state.supportNonClosedChatList = action.payload.$values.map((item) => {
              return {
                ...item,
                supportChatMessages: item.supportChatMessages.$values
              }
            })
            state.supportChatList = action.payload.$values.map((item) => {
              return {
                ...item,
                supportChatMessages: item.supportChatMessages.$values
              }
            })
        })
        .addCase(getNonClosedChats.rejected, (state, action) => {
            state.getIsLoading = false
            state.getIsError = true
        })

        //! arşivlenen mesajlar
        .addCase(getClosedChats.pending, (state, action) => {
          state.getIsLoading = true
        })
        .addCase(getClosedChats.fulfilled, (state, action) => {
            state.getIsLoading = false
            state.supportClosedChatList = action.payload.$values.map((item) => {
              return {
                ...item,
                supportChatMessages: item.supportChatMessages.$values
              }
            })
        })
        .addCase(getClosedChats.rejected, (state, action) => {
            state.getIsLoading = false
            state.getIsError = true
        })

        //! mesajlaşma
        
        .addCase(sendChatMessage.pending, (state, action) => {
          state.addIsLoading = true
        })
        .addCase(sendChatMessage.fulfilled, (state, action) => {
            state.addIsLoading = false
            state.selectedChat = {...state.selectedChat, supportChatMessages: [...state.selectedChat.supportChatMessages, action.payload]}
        })
        .addCase(sendChatMessage.rejected, (state, action) => {
            state.addIsLoading = false
            state.addIsError = true
        })

        //! mesaj oluşturma
        .addCase(createChatMessage.pending, (state, action) => {
          state.addIsLoading = true
        })
        .addCase(createChatMessage.fulfilled, (state, action) => {
            state.addIsLoading = false
            state.selectedChat = {...action.payload, supportChatMessages: action.payload.supportChatMessages.$values}
            state.supportChatList = [...state.supportChatList, {...action.payload, supportChatMessages: action.payload.supportChatMessages.$values}]
        })
        .addCase(createChatMessage.rejected, (state, action) => {
            state.addIsLoading = false
            state.addIsError = true
        })

        //! id ile mesaj çekme
        .addCase(getSupportChatById.pending, (state, action) => {
          state.getIsLoading = true
        })
        .addCase(getSupportChatById.fulfilled, (state, action) => {
          state.getIsLoading = false
          state.supportChatList = state.supportChatList.map((item) => {
            if(item.id === action.payload.id){
              return {...action.payload, supportChatMessages: action.payload.supportChatMessages.$values}
            }else {
              return item
            }
          })
          if(state.selectedChat && state.selectedChat.id === action.payload.id){
            state.selectedChat = {...action.payload, supportChatMessages: action.payload.supportChatMessages.$values}
          }
        })
        .addCase(getSupportChatById.rejected, (state, action) => {
            state.getIsLoading = false
            state.getIsError = true
        })

        //! konuşma bitirme talebi
        
        .addCase(closeSupportChatDemand.pending, (state, action) => {
          state.addIsLoading = true
        })
        .addCase(closeSupportChatDemand.fulfilled, (state, action) => {
            state.addIsLoading = false
            state.supportChatList = state.supportChatList.map((item) => {
              if(item.id === action.payload.id){
                return {...action.payload, supportChatMessages: action.payload.supportChatMessages.$values}
              }else {
                return item
              }
            })
            state.selectedChat = {...action.payload, supportChatMessages: action.payload.supportChatMessages.$values}
        })
        .addCase(closeSupportChatDemand.rejected, (state, action) => {
            state.addIsLoading = false
            state.addIsError = true
        })

        //! konuşma bitirme
        .addCase(closeSupportChat.pending, (state, action) => {
          state.addIsLoading = true
        })
        .addCase(closeSupportChat.fulfilled, (state, action) => {
            state.addIsLoading = false
            state.supportChatList = state.supportChatList.map((item) => {
              if(item.id === action.payload.id){
                return {...action.payload, supportChatMessages: action.payload.supportChatMessages.$values}
              }else {
                return item
              }
            })
            state.selectedChat = {...action.payload, supportChatMessages: action.payload.supportChatMessages.$values}
        })
        .addCase(closeSupportChat.rejected, (state, action) => {
            state.addIsLoading = false
            state.addIsError = true
        })

        //! mesaj okundu
        
        .addCase(setMessageRead.pending, (state, action) => {
          state.addIsLoading = true
        })
        .addCase(setMessageRead.fulfilled, (state, action) => {
            state.addIsLoading = false
            state.supportChatList = state.supportChatList.map((item) => {
              if(item.id === action.payload.id){
                return {
                  ...action.payload,
                  supportChatMessages: action.payload.supportChatMessages.$values
                }
              }else {
                return item
              }
            })
            if(state.selectedChat && state.selectedChat.id === action.payload.id){
              state.selectedChat = {...action.payload, supportChatMessages: action.payload.supportChatMessages.$values}
            }
        })
        .addCase(setMessageRead.rejected, (state, action) => {
            state.addIsLoading = false
            state.addIsError = true
        })
    }
})


export const {setSelectedChat, setSelectedCategory, setSelectedSubCategory, setSubCategoryList, updateSignalRSupportChatList, setSelectedFile, setArchiveChat} = messageSlice.actions
export default messageSlice.reducer
